// frontend/src/pages/public/LegalLayout.jsx
import React from "react";
import { NavLink, Outlet, useLocation } from "react-router-dom";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";
import { Container, cx } from "../../marketing/ui";
import { LEGAL_DOCS, LEGAL_LAST_UPDATED } from "../../marketing/data/legal";

const SIDEBAR = [
  { to: "/legal", label: "Overview", end: true },
  ...LEGAL_DOCS.map((d) => ({ to: `/legal/${d.slug}`, label: d.title })),
  { to: "/legal/privacy", label: "Privacy Policy" },
  { to: "/security", label: "Security" },
];

export default function LegalLayout() {
  const { pathname } = useLocation();
  // The Privacy Policy is the operative GDPR document (authored to reflect real
  // practice), not one of the generated draft templates — so skip the banner there.
  const showDraftBanner = pathname !== "/legal/privacy";

  const linkClass = ({ isActive }) =>
    cx(
      "block rounded-lg px-3 py-2 text-sm",
      isActive ? "bg-brand-50 font-semibold text-brand-700" : "text-gray-600 hover:bg-gray-50 hover:text-gray-900",
    );

  return (
    <Container className="py-12">
      <div className="md:grid md:grid-cols-[230px_minmax(0,1fr)] md:gap-10">
        <aside className="mb-8 md:mb-0">
          <nav className="md:sticky md:top-24">
            <p className="px-3 text-xs font-semibold uppercase tracking-wide text-gray-400">
              Legal
            </p>
            <div className="mt-2 space-y-1">
              {SIDEBAR.map((l) => (
                <NavLink key={l.to} to={l.to} end={l.end} className={linkClass}>
                  {l.label}
                </NavLink>
              ))}
            </div>
            <p className="mt-6 px-3 text-xs text-gray-400">Last updated: {LEGAL_LAST_UPDATED}</p>
          </nav>
        </aside>

        <div className="min-w-0">
          {/* Draft-for-counsel banner — applies to the generated policy templates. */}
          {showDraftBanner && (
            <div className="mb-8 flex items-start gap-3 rounded-xl border border-amber-200 bg-amber-50 p-4 print:hidden">
              <ExclamationTriangleIcon className="h-5 w-5 flex-none text-amber-600" aria-hidden="true" />
              <p className="text-sm text-amber-800">
                <strong>Draft template.</strong> These policies are provided for convenience and
                must be reviewed by qualified legal counsel before launch. They are not legal
                advice.
              </p>
            </div>
          )}
          <Outlet />
        </div>
      </div>
    </Container>
  );
}
